<template>
    <v-menu v-model="open" offset-y zIndex="202" :closeOnContentClick="false">
        <template v-slot:activator="{ on }">
            <v-btn :color="value" tile dark v-on="on" x-small style="min-width: 20px;"></v-btn>
        </template>
        <v-card>
            <v-color-picker v-model="pickedColor" show-swatches class="mx-auto">
            </v-color-picker>
            <v-row no-gutters justify="space-between">
                <v-btn @click="close()" color="close" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn @click="resetToDefault()" color="warning" icon>
                    <v-icon>mdi-cloud-refresh-variant</v-icon>
                </v-btn>
                <v-btn @click="save()" color="success" icon>
                    <v-icon>mdi-check</v-icon>
                </v-btn>
            </v-row>
        </v-card>
    </v-menu>
</template>


<script>
export default {
    name: 'ColorPickerMenu',
    props: {
        value: String,
        defaultColor: {
            type: String,
            default: '#000000',
        },
    },
    components: {},

    data() {
        return {
            open: false,
            pickedColor: '#000000',
        };
    },

    mounted() {
        this.resetSelection();
    },

    methods: {
        resetSelection() {
            this.pickedColor = this.value ?? this.defaultColor;
        },

        save() {
            this.$emit('input', this.pickedColor);
            this.$emit('changed', this.pickedColor);
            this.close();
        },

        resetToDefault() {
            this.$emit('input', this.defaultColor);
            this.close();
        },

        close() {
            this.open = false;
        },
    },

    computed: {},

    watch: {
        value: function (val) {
            this.pickedColor = val;
        },
        
        open: function (val) {
            if (val) { this.resetSelection(); }
        },
    },
};
</script>


<style lang='scss' scoped></style>